import { Component, OnDestroy, OnInit } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { OccConfig, RoutingService, SiteContextParamsService, TranslatePipe } from '@spartacus/core';
import { Observable, Subscription, asapScheduler, of } from 'rxjs';
import { catchError, observeOn, take, timeout } from 'rxjs/operators';
import { KnBrCartContextActionTypes } from '../../../store/kn-br-cart-context/kn-br-cart-context.actions';
import { KnBrCustomerContextService } from '../../../store/kn-br-customer-context/kn-br-customer-context.service';
import { KnBrCustomerService } from '../../../store/kn-br-customer/kn-br-customer.service';
import { CustomerData } from './../../../models/customer.model';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { cloneDeep, isEmpty } from 'lodash';
import { AsyncPipe, JsonPipe } from '@angular/common';
import { PaginationComponent, SpinnerComponent } from '@spartacus/storefront';
import { RemoveLeadingZerosPipe } from '../../../shared/pipe/kn-br-custom-pipes/remove-leading-zeros.pipe';

@Component({
    selector: 'knbr-customer-search-result',
    templateUrl: './kn-br-customer-search-result.component.html',
    styleUrls: ['./kn-br-customer-search-result.component.scss'],
    imports: [PaginationComponent, SpinnerComponent, AsyncPipe, TranslatePipe, RemoveLeadingZerosPipe, JsonPipe]
})

export class KnBrCustomerSearchResultComponent implements OnInit,OnDestroy {
  customerSearchSubscription: any;
  customerResult$: Observable<CustomerData[]> = this.customerSearchService.list$;
  isLoading$: Observable<boolean> = this.customerSearchService.loading$;
  routedFrom: string;
  copyObject: any;
  searchCriteria: any;
  subscription: Subscription;
  constructor(
    private customerSearchService: KnBrCustomerService,
    private routingService: RoutingService,
    private customerContextService: KnBrCustomerContextService,
    protected config: OccConfig,
    protected siteContextParamsService: SiteContextParamsService,
    private knbrCommonService: KnBrCommonService,
    private actions$: Actions
  ) {}
  ngOnInit(): void {
    this.subscription = this.customerSearchService.searchCriteria$.subscribe((response) => {
      this.searchCriteria = cloneDeep(response);
    });
  }
  storeInContext(customer: CustomerData) {
    this.customerContextService
      .getActiveCustomerNumber()
      .pipe(take(1))
      .subscribe((current) => {
        const customerChanged = current !== customer.customerNumber;
        // The page reload below would cancel the in-flight cart request, so wait for its result first.
        const cartResolved$ = customerChanged
          ? this.actions$.pipe(
              ofType(
                KnBrCartContextActionTypes.KnBrCartContextAddUpdateAction,
                KnBrCartContextActionTypes.KnBrCartContextResetAction
              ),
              take(1),
              timeout({ first: 15000 }),
              catchError(() => of(null)),
              observeOn(asapScheduler)
            )
          : of(null);

        cartResolved$.subscribe(() => this.redirectToSite(customer));
        this.customerContextService.set(customer);
      });
  }

  private redirectToSite(customer: CustomerData) {
    const indexOfSite =  this.config.context.country.indexOf(customer.countryCode.toLowerCase())
    if(indexOfSite > -1) {
      const site = this.config.context.baseSite[indexOfSite];
      const currency = this.config.context.currency[indexOfSite]
      this.siteContextParamsService.setValue('baseSite', site);
      this.siteContextParamsService.setValue('currency',currency);
      window.location.href = `/${site}/${currency}`;
    } else {
      this.routingService.go({ cxRoute: 'home' });
    }
  }

  pageChange(page: number): void {
    if (this.searchCriteria) {
      this.searchCriteria.currentPage = page;
    }
    this.customerSearchService.search(this.searchCriteria);
  }
  formatState(state) {
    return this.knbrCommonService.formatState(state);
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    };
  }
}
